import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {BusinessList} from 'components/fair/fair-business';
import {Link} from 'react-router-dom';

export default class FairBusinessAwaiting extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Các doanh nghiệp tham gia hội chợ</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/businesses`}>Doanh nghiệp của hội chợ</Link>
            </div>
          </div>
          <BusinessList status="AWAITING" match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-business/FairBusinessAwaiting.jsx